/**
 * @file index.tsx
 * @deprecated Copied to app/modules/procurement/pages/assign-product-to-vendors/index.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/assign-product-to-vendors/index
 * @description Route wrapper for the Assign Products to Vendors module in uProcure.
 *   Provides breadcrumbs, page title, and nested routing for the assign products page.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import AssignProductsToVendors from "./assign-product-to-vendors";
import { PageLink, PageTitle } from "../../../../_admin/layout/core";
const assignProductToVendorBreadCrumbs: Array<PageLink> = [
  {
    title: "UProcure",
    path: "/UProcure",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];
const AssignProductsToVendorsPage = () => {
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            index
            element={
              <>
                <PageTitle breadcrumbs={assignProductToVendorBreadCrumbs}>
                  Assign Products to Vendors
                </PageTitle>
                <AssignProductsToVendors />
              </>
            }
          />
        </Route>
      </Routes>
    </>
  );
};

export default AssignProductsToVendorsPage;
